import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import CreateContractFigure from "../../../../assets/images/create-contract-img.png";

const ProviderWithoutContract = () => {
  const { t } = useTranslation("goService", {
    keyPrefix: "serviceRequestPage",
  });

  return (
    <Box sx={styles.container}>
      <Box sx={styles.content}>
        <Box component="img" src={CreateContractFigure} alt="create-contract-figure" sx={styles.figure} />
        <Typography sx={styles.title}>{t("noContracts")}</Typography>
      </Box>
    </Box>
  );
};

export default ProviderWithoutContract;

const styles = {
  container: {
    height: "fit-content",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
    display: "flex",
    padding: "80px 20px",
    flexDirection: "column",
    alignItems: "center",
    gap: "40px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  title: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    textAlign: "center",
  },
  figure: {
    width: "92.711px",
    height: "111.427px",
  },
};
